import { useIsAdminQuery } from '@repo/studio-hooks-user/use-is-admin-query'

export function useIsAidaAllowed() {
  const isAdminQuery = useIsAdminQuery()
  if (process.env.VITE_PUBLIC_ENV !== 'production') {
    return true
  }
  return isAdminQuery.data === true
}
